import { Routes, mapToCanActivate, mapToCanDeactivate } from "@angular/router";

import { BaseGuardService } from "../auth/guards/base-guard.service";
import { PaymentCheckoutComponent } from "./components/payment-checkout/payment-checkout.component";
import { PaymentResponseComponent } from "./components/payment-response/payment-response.component";
import { PaymentReportComponent } from "./components/payment-report/payment-report.component";

// TESTER
import { InternalGuardService } from "../auth/guards/internal-guard.service";
import { SystemPermissionGuardService } from "../auth/guards/system-permission-guard.service";
import { LunaClaimValues, LunaClaimTypes } from "../models/user-identity.model";
import { PaymentInvoiceComponent } from "./components/payment-invoice/payment-invoice.component";
import { PaymentOpenItemsReportComponent } from "./components/payment-open-items-report/payment-open-items-report.component";
import { RequestPaymentAdjustmentComponent } from "./components/request-payment-adjustment/request-payment-adjustment.component";
import { ApprovePaymentAdjustmentComponent } from "./components/approve-payment-adjustment/approve-payment-adjustment.component";
import { MasterGuardService } from "../auth/guards/master-guard.service";
import { CanDeactivateGuardService } from "../auth/guards/can-deactivate-guard.service";
import { GuardList } from "../auth/guards/guard-list.enum";

const routeGuards = [BaseGuardService];
const systemPermissionGuards = [SystemPermissionGuardService];


export const PAYMENTS_ROUTES: Routes = [ 
    {
        path: "payment-report",
        component: PaymentReportComponent,
        canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: LunaClaimValues.PaymentReport }
    },
    {
        path: 'transaction/:id',
        canActivate: mapToCanActivate(routeGuards),
        component: PaymentInvoiceComponent
    },
    {
        path: "payment-open-items-report",
        component: PaymentOpenItemsReportComponent,
		canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: LunaClaimValues.PaymentReport }
    },
    {
        path: 'request-payment-adjustment',
        component: RequestPaymentAdjustmentComponent,
		canActivate: mapToCanActivate(systemPermissionGuards),
        data: { claims: [{ type: LunaClaimTypes.Widget, value: LunaClaimValues.ViewPendingPaymentsWidget }] },
		canDeactivate: mapToCanDeactivate([ CanDeactivateGuardService ])
    },
    {
        path: 'approve-payment-adjustment/:id',
        component: ApprovePaymentAdjustmentComponent,
        canActivate: mapToCanActivate([MasterGuardService]),
        data: {
            guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
            permission: LunaClaimValues.ApprovePaymentAdjustments
        },
		canDeactivate: mapToCanDeactivate([ CanDeactivateGuardService ])
    }
]